<div class="general-settings">
    <div class="general-settings__settings-container settings-container">
        <div class="settings-container__user-setting user-settings">
            <div class="user-settings__title setting-title" [translate]="'settings.general.user-settings-header'"></div>
            <div class="user-settings__setting-row setting-row">
                <div class="column_w_30">
                    <div class="user-settings__label setting-label" [translate]="'settings.general.change-password-label'"></div>
                </div>
                <div class="column_w_15">
                    <a (click)="onChangePassword($event)" href="#" class="setting-link"
                        [translate]="'settings.general.change-password-link'"></a>
                </div>
            </div>
        </div>
        <div class="settings-container__user-setting app-settings">
            <div class="app-settings__title setting-title" [translate]="'settings.general.application-settings-header'"></div>
            <div class="app-settings__setting-row setting-row">
                <div class="column_w_30">
                    <div class="app-settings__label setting-label" [translate]="'settings.general.change-language-label'"></div>
                </div>
                <div class="column_w_15">
                    <ng-select class="custom"
                               [items]="languages"
                               bindLabel="label"
                               bindValue="code"
                               [clearable]="false"
                               [(ngModel)]="currentLanguage"
                               (change)="onLanguageChange($event)"
                               [searchable]="false">
                      <ng-template ng-label-tmp let-item="item">
                        <span class="select-label-name" data-test="language-value">{{ item.label }}</span>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item">
                        <span class="select-option-name" data-test="language-option">{{ item.label }}</span>
                      </ng-template>
                    </ng-select>
                </div>
            </div>
            <div class="app-settings__setting-row setting-row">
                <div class="column_w_30">
                    <div class="app-settings__label setting-label">
                        {{"settings.general.number-scale-label" | translate }}
                    </div>
                </div>
                <div class="column_w_15">
                    <ng-select class="custom"
                               [clearable]="false"
                               [items]="currencies"
                               bindLabel="currencyName"
                               [(ngModel)]="selectedCurrency"
                               [searchable]="false"
                               (change)="onCurrencyChange($event)">
                      <ng-template ng-label-tmp let-item="item">
                        <span class="select-label-name" data-test="currency-name-value">{{ item.currencyName }}</span>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item">
                        <span class="select-option-name" data-test="currency-name-option">{{ item.currencyName }}</span>
                      </ng-template>
                    </ng-select>

                    <ng-select class="custom setting-select"
                               [items]="fractionDigits"
                               bindLabel="name"
                               bindValue="id"
                               [searchable]="false"
                               [clearable]="false"
                               [(ngModel)]="selectedMaxFractionDigits"
                               (change)="onMaxFractionDigitChange($event)">
                      <ng-template ng-label-tmp let-item="item">
                        <span class="select-label-name" data-test="precision-value">{{ item.name }}</span>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item">
                        <span class="select-option-name" data-test="precision-option">{{ item.name }}</span>
                      </ng-template>
                    </ng-select>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="isLoading" class="panel">
      <app-loader></app-loader>
    </div>
</div>
